import { render } from "./workflow_select.vue?vue&type=template&id=678d3dee&scoped=true"
import script from "./workflow_select.vue?vue&type=script&lang=js"
export * from "./workflow_select.vue?vue&type=script&lang=js"

import "./workflow_select.vue?vue&type=style&index=0&id=678d3dee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678d3dee"]])

export default __exports__